
  const data = {};

  class CSRLabelModel {
    constructor() {}

    parseData(dataString) {
      const pairs = dataString.split(',');
      const regex = new RegExp('^([^:]+):(.*)', 'g');
      let group;
      for (let i = 0, leni = pairs.length; i < leni; i++) {
        group = regex.exec(pairs[i]);
        if (group && group.length) {
          data[group[1]] = group[2];
        }
        regex.lastIndex = 0;
      }
    }

    getData() {
      return data;
    }
  }

  export default new CSRLabelModel();

